import styled from 'styled-components';

export const Title1 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-title1-font-family);
  font-size: var(--typo-title1-font-size);
  letter-spacing: var(--typo-title1-letter-spacing);
  line-height: var(--typo-title1-line-height);
  font-weight: var(--typo-title1-font-weight);
`;

export const Title2 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-title2-font-family);
  font-size: var(--typo-title2-font-size);
  letter-spacing: var(--typo-title2-letter-spacing);
  line-height: var(--typo-title2-line-height);
  font-weight: var(--typo-title2-font-weight);
`;

export const Title3 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-title3-font-family);
  font-size: var(--typo-title3-font-size);
  letter-spacing: var(--typo-title3-letter-spacing);
  line-height: var(--typo-title3-line-height);
  font-weight: var(--typo-title3-font-weight);
`;

export const Title4 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-title4-font-family);
  font-size: var(--typo-title4-font-size);
  letter-spacing: var(--typo-title4-letter-spacing);
  line-height: var(--typo-title4-line-height);
  font-weight: var(--typo-title4-font-weight);
`;

export const Title5 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-title5-font-family);
  font-size: var(--typo-title5-font-size);
  letter-spacing: var(--typo-title5-letter-spacing);
  line-height: var(--typo-title5-line-height);
  font-weight: var(--typo-title5-font-weight);
`;

export const Title6 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-title6-font-family);
  font-size: var(--typo-title6-font-size);
  letter-spacing: var(--typo-title6-letter-spacing);
  line-height: var(--typo-title6-line-height);
  font-weight: var(--typo-title6-font-weight);
`;

export const FormText = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-form-font-family);
  font-size: var(--typo-form-font-size);
  letter-spacing: var(--typo-form-letter-spacing);
  line-height: var(--typo-form-line-height);
  font-weight: var(--typo-form-font-weight);
`;

export const FormTips = styled.span`
  color: var(--colors-on-secondary);
  font-family: var(--typo-tips-font-family);
  font-size: var(--typo-tips-font-size);
  letter-spacing: var(--typo-tips-letter-spacing);
  line-height: var(--typo-tips-line-height);
  font-weight: var(--typo-tips-font-weight);
`;

export const Caption = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-caption-font-family);
  font-size: var(--typo-caption-font-size);
  letter-spacing: var(--typo-caption-letter-spacing);
  line-height: var(--typo-caption-line-height);
  font-weight: var(--typo-caption-font-weight);
`;

export const FormText2 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-form2-font-family);
  font-size: var(--typo-form2-font-size);
  letter-spacing: var(--typo-form2-letter-spacing);
  line-height: var(--typo-form2-line-height);
  font-weight: var(--typo-form2-font-weight);
`;

export const FormText3 = styled.span`
  color: var(--colors-on-background);
  font-family: var(--typo-form3-font-family);
  font-size: var(--typo-form3-font-size);
  letter-spacing: var(--typo-form3-letter-spacing);
  line-height: var(--typo-form3-line-height);
  font-weight: var(--typo-form3-font-weight);
`;
